import apiClient from '@/utils/request'
import { IResponseMeta } from '@/api/types'

interface IDashboardResponse<T = any> {
  result: T
  meta: IResponseMeta
}

export const getBalanceActivity = async (): Promise<IDashboardResponse> => {
  const response = await apiClient.get<IDashboardResponse>('/dashboards/info')
  return response.data
}

export const getSpendingActivity = async (
  periodId: number
): Promise<IDashboardResponse> => {
  const response = await apiClient.get<IDashboardResponse>(
    `/dashboards/spending_activity?period=${periodId}`
  )
  return response.data
}

export const getFullActivity = async (
  typeId: number
): Promise<IDashboardResponse> => {
  const response = await apiClient.get<IDashboardResponse>(
    `/dashboards/full_activity?type_id=${typeId}`
  )
  return response.data
}

export const getRealTimeActivity = async (
  typeId: number
): Promise<IDashboardResponse> => {
  const response = await apiClient.get<IDashboardResponse>(
    `/dashboards/realtime?type_id=${typeId}`
  )
  return response.data
}

export const getIncomeActivity = async (
  groupBy: string,
  period: number
): Promise<IDashboardResponse> => {
  const response = await apiClient.get<IDashboardResponse>(
    `/dashboards/income?group_by=${groupBy}&period=${period}`
  )
  return response.data
}

export const getMarketStat = async (): Promise<IDashboardResponse> => {
  const response = await apiClient.get<IDashboardResponse>('/dashboards/market')
  return response.data
}

export const getCPMWidgetData = async (
  adType: number,
  country: string
): Promise<IDashboardResponse> => {
  const response = await apiClient.get<IDashboardResponse>(
    `/dashboards/cpm_widget?type_id=${adType}&country_id=${country || 0}`
  )
  return response.data
}

export const getRevenueByWebsitesWidgetData = async (
  typeId = 0
): Promise<IDashboardResponse> => {
  const response = await apiClient.get<IDashboardResponse>(
    `/dashboards/revenue_by_websites_widget?type_id=${typeId}`
  )
  return response.data
}

export const getRevenueByTrafficSourcesWidgetData =
  async (): Promise<IDashboardResponse> => {
    const response = await apiClient.get<IDashboardResponse>(
      '/dashboards/revenue_by_traffic_sources_widget'
    )
    return response.data
  }
